<template>
  <div>
    <slotBase :bg-grey="true" :footerRadius="true">
      <template v-slot:content>
        <div
          class="main p-a-16"
          style="display: flex; align-items: center; height: 90vh"
        >
          <div class="w-100">
            <div class="card-one d-flex">
              <div
                class="card p-0 shadow"
                style="border-radius: 15px; width: -webkit-fill-available"
              >
                <div class="card-header p-0">
                  <div class="sd-heading">
                    <img
                      src="../../../assets/logo.jpg"
                      alt="Profile Picture"
                      class="profile-pic"
                    />
                  </div>
                </div>

                <div class="sd-body p-a-16">
                  <p class="f-Overpass f-14 f-w-400 f-c-black m-0">
                    Masukkan kata sandi baru
                  </p>

                  <div class="p-t-20">
                    <label
                      for="password"
                      class="form-label f-Overpass f-14 f-c-grey f-w-400 m-0"
                      >Kata Sandi <span class="spn-2">*</span></label
                    >
                    <input
                      :type="!btnEye ? 'password' : 'text'"
                      class="input-form-password f-16 p-t-12 p-b-12 f-Overpass"
                      id="password"
                      placeholder="Masukkan Kata Sandi"
                      v-model="passwordUser"
                    />
                    <span
                      toggle="#password"
                      class="button-eye"
                      @click="btnEyeEvent"
                      ><font-awesome-icon
                        :icon="
                          !btnEye
                            ? 'fa-regular fa-eye'
                            : 'fa-regular fa-eye-slash'
                        "
                        rotation="180"
                        style="color: #6f7287"
                      />
                    </span>
                  </div>

                  <div class="p-t-20 p-b-20">
                    <label
                      for="password"
                      class="form-label f-Overpass f-14 f-c-grey f-w-400 m-0"
                      >Ulangi Kata Sandi <span class="spn-2">*</span></label
                    >
                    <input
                      :type="!btnEye2 ? 'password' : 'text'"
                      class="input-form-password f-16 f-Overpass"
                      id="password2"
                      placeholder="Masukkan Kata Sandi Baru"
                      v-model="passwordUser2"
                    />
                    <span
                      toggle="#password2"
                      class="button-eye"
                      @click="btnEyeEvent2"
                      ><font-awesome-icon
                        :icon="
                          !btnEye2
                            ? 'fa-regular fa-eye'
                            : 'fa-regular fa-eye-slash'
                        "
                        rotation="180"
                        style="color: #6f7287"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="p-x-24 p-t-16 p-b-16">
          <button
            type="button"
            class="btn btn-primary w-100 f-Overpass"
            style="font-size: 16px; margin-top: 12px"
            @click="handleButtonClick"
            :disabled="btnRegister === true ? true : false"
          >
            <span
              class="spinner-border text-light f-16 spiner-border-sm"
              v-if="btnRegister"
            ></span>
            <span v-if="!btnRegister">Simpan</span>
          </button>
        </div>
      </template>
    </slotBase>
  </div>
</template>

<script>
import slotBase from "@/components/slots/slotBase.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "registerApp",
  components: {
    slotBase,
  },

  data() {
    return {
      btnEye: false,
      btnEye2: false,
      noTelp: "",
      passwordUser: "",
      passwordUser2: "",
      namaAkun: "",
      btnRegister: false,
    };
  },

  computed: {
    ...mapState("auth", {
      dataOtpGanti: "dataOtpGanti",
      dataPasswordChange: "dataPasswordChange",
    }),
  },

  methods: {
    ...mapActions({
      postForgotPassword: "auth/postForgotPassword",
    }),
    routeToLogin() {
      this.$router.push({ name: "login" });
      location.reload();
    },
    btnEyeEvent() {
      if (!this.btnEye) {
        return (this.btnEye = true);
      } else {
        return (this.btnEye = false);
      }
    },

    btnEyeEvent2() {
      if (!this.btnEye2) {
        return (this.btnEye2 = true);
      } else {
        return (this.btnEye2 = false);
      }
    },

    async handleButtonClick() {
      this.btnRegister = true;
      if (this.passwordUser && this.passwordUser2) {
        if (this.passwordUser === this.passwordUser2) {
          let data = {
            otp: this.dataOtpGanti,
            telp: "62" + this.$route.params.noTelp,
            password: this.passwordUser,
          };
          await this.postForgotPassword(data).then((res) => {
            if (res.status == 200) {
              this.$toast.success("Sandi diperbaruhi", { position: "top" });
              this.$router.push({ name: "login" });
              location.reload();
            }

            if (res.status != 200) {
              this.$router.push({ name: "forgotPasswordTelp" });
              location.reload();
              this.$toast.error("Mohon coba lagi", { position: "top" });
              this.$toast.error("Kesalahan sistem", { position: "top" });
            }
          });
          this.$store.commit("auth/requestPasswordChange", data);
        } else {
          this.btnRegister = false;
          this.$toast.error("Password Tidak Sama", { position: "top" });
        }
      } else {
        this.btnRegister = false;
        this.$toast.error("Form Belum Lengkap", { position: "top" });
      }
    },
  },
};
</script>

<style scoped>
.card-one {
  border-radius: 16px;
  background: var(--primary-white, #fff);
  box-shadow: 0px 4px 12px 0px rgba(0, 34, 119, 0.06);
  align-items: center;
  width: -webkit-fill-available;
}

.profile-pic {
  width: 110px; /* Set the width and height of the circular image */
  height: 110px;
  border-radius: 70%; /* Create a circular shape */
  position: absolute; /* Position the image absolutely */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 1%;
  left: 50%; /* Position horizontally at the center */
  transform: translate(-50%, -50%);
}

.sd-heading {
  background-color: #206cfe;
  height: 70px;
  color: #fff;
  align-self: stretch;
  border-radius: 16px 16px 0px 0px;
  background: var(--primary-product-smartlink, #206cfe);
}

/* .spsl-1 {
    color: #206cfe;
    font-size: 16px;
  } */

/* .footer {
    width: 100%;
    height: 145px;
    padding: 15px;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    gap: 8px;
    background-color: white;
    box-shadow: 0px 4px 12px 0px rgba(0, 34, 119, 0.06);
    position: absolute;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
  } */
.spn-2 {
  color: #007bff;
}

.button-eye {
  transform: translateY(30%);
  position: absolute;
  right: 0;
  padding-right: 30px;
}
</style>
